<template>
  <div>
    <div class="img-container relative-position" ref="img-container">
      <template v-if="url">
        <img width="20px" :data-src="url" @load="onImageLoad" ref="image" />

        <div
          class="rounder-borders row items-center justify-center"
          style="height: 20px; width: 20px"
          v-if="!loaded && url"
        >
          <q-spinner-dots color="secondary" size="12px" />
        </div>
      </template>

      <template v-else>
        <q-icon name="local_offer" size="20px" class="no-promo-icon" />
      </template>

      <q-tooltip :delay="500">
        {{ imageTooltip }}
      </q-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: "DOverlayDatesListImage",
  data() {
    return {
      loaded: false,
      observer: null,
    };
  },
  props: {
    url: {
      type: String,
      default: "",
    },
    imageTooltip: {
      type: String,
      required: true,
    },
  },
  mounted() {
    if (!this.$refs.image) {
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((e) => e.isIntersecting)) {
          return;
        }

        if (!entries[0].target.getAttribute("data-src")) {
          this.observer.disconnect();
          return;
        }

        entries[0].target.src = entries[0].target.getAttribute("data-src");
        this.observer.disconnect();
      },
      {
        rootMargin: "250px",
        threshold: 0,
      }
    );
    this.observer.observe(this.$refs.image);
  },
  methods: {
    onImageLoad(e) {
      const { naturalWidth, naturalHeight } = e.target;

      if (naturalWidth >= naturalHeight) {
        e.target.style.width = "100%";
        e.target.style.height = "auto";
      } else {
        e.target.style.width = "auto";
        e.target.style.height = "100%";
      }

      this.loaded = true;
    },
  },
  beforeUnmount() {
    this.observer.disconnect();
    this.observer = null;
  },
};
</script>

<style lang="scss" scoped>
.img-container {
  width: 20px;
  height: 20px;
}

img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.no-promo-icon {
  color: rgba($color: #000000, $alpha: 0.54);
}
</style>
